export const useConstants = () => {
	return {
        PROJECT: '66ec50bb98be6e4d7118b66b',
        POST: '66ec504498be6e4d7118b62e',
        DOWNLOADER: '66ec50a398be6e4d7118b63a'
    }
};